import { render, staticRenderFns } from "./AppSearchSinister.vue?vue&type=template&id=53b8373d"
import script from "./AppSearchSinister.vue?vue&type=script&lang=js"
export * from "./AppSearchSinister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports